import React, { useState, useEffect } from 'react'
import Form from 'react-bootstrap/Form';
import '../assets/main.css';
import '../assets/admin.css';

import Logo from '../assets/logos/logo.png'
import toast, { Toaster } from 'react-hot-toast';
import favIcon from '../assets/logos/favicon.png'
import { Link } from 'react-router-dom';
import { useAdminSettingsQuery, useStatusUpdateValMutation } from './store/ReduxApis';


function ModuleEnableSettings() {

    const data = useAdminSettingsQuery();
    console.log(data)

    const [createPost, responseInfo] = useStatusUpdateValMutation();


    const [host, setHost] = useState("")
    const [port, setPort] = useState("")
    const [user, setUser] = useState("")
    const [password, setPassword] = useState("")
    const [audience, setAudience] = useState("")



    const newPost = {
        "settings": {
            "audience": audience,
            "host": host,
            "port": port,
        }


    }

    const audiences = data?.data?.settings?.buy;
    const ports = data?.data?.settings?.claim;
    const hosts = data?.data?.settings?.rewardclaim;


    useEffect(() => {

        setAudience(audiences);
        setPort(ports);
        setHost(hosts);


    }, [])

    useEffect(() => {
        if (data?.data?.settings) {
            setAudience(audiences);
            setPort(ports);
            setHost(hosts);
        }
    }, [data]);

    const handleToggle = async (key, value) => {
        // e.preventDefault(e)
        // createPost(newPost)

        try {
            const response = await createPost({ key, value }).unwrap();
            console.log("moduleResponse:", response.status)

            // Check API response for message
            if (response?.status === "success") {
                toast(`Status for ${key} updated successfully!`);
                setTimeout(() => {
                    window.location.reload(false);
                }, 1500)
            } else {
                toast(`Failed to update status for ${key}!`);
            }
        } catch (error) {
            const errorMessage = error?.data?.message || `Failed to update status for ${key}!`;
            toast.error(errorMessage);
        }
    }

    // const handleToggle = async (key, value) => {
    //     try {
    //         await updateStatus({ key, value }).unwrap();
    //         toast.success(`Status for ${key} updated successfully!`);
    //     } catch (error) {
    //         toast.error(`Failed to update status for ${key}!`);
    //     }
    // };

    return (

        <section className="content pages">
            <Toaster />
            <div className='mainPage'>
                <h3>Module Settings</h3>
            </div>
            <div className="row">
                <div className="firstBox" >
                    <div className='box box-info'>


                        <div className="box-header with-border">
                            <h5 className="title">Manage Settings</h5>
                        </div>

                        <div className='icons'>
                            <i class="fas fa-cog"></i>
                            <li><Link className='link' to="/general">General</Link></li>

                        </div>
                        <div className='icons'>
                            <i class="fas fa-lock"></i>
                            <li><Link className='link' to="/emailSettings">Email Settings</Link></li>
                        </div>
                        <div className='icons'>
                            <i class="fas fa-key"></i>
                            <li><Link className='link' to="/moduleSettings">Module Settings</Link></li>
                        </div>
                        <div className='icons'>
                            <i class="fas fa-cog"></i>
                            <li><Link className='link' to="/email">Email Template Settings</Link></li>
                        </div>
                        <div className='icons'>
                            <i class="fas fa-share-alt"></i>
                            <li><Link className='link' to="/password">Password Settings</Link></li>
                        </div>
                        <div className='icons'>
                            <i class="fas fa-cog"></i>
                            <li><Link className='link' to="/account">Token Contribution Settings</Link></li>
                        </div>
                        <div className='icons'>
                            <i class="fab fa-google"></i>
                            <li><Link className='link' to="/contractAddress">Contract Address Settings</Link></li>
                        </div>
                        <div className='icons'>
                            <i class="fas fa-key"></i>
                            <li><Link className='link' to="/referral-bonus">Referral Bonus Distribution Setting</Link></li>
                        </div>
                        <div className='icons'>
                            <i class="fab fa-google"></i>
                            <li><Link className='link' to="/details">Admin Details</Link></li>
                        </div>
                        <div className='icons'>
                            <i class="fas fa-cog"></i>
                            <li><Link className='link' to="/status">Social Media Link</Link></li>
                        </div>


                    </div>
                </div>

                <div className="col-md-8" style={{ width: "60%" }}>
                    <div className="box box-info">
                        <div className="box-header with-border">
                            <h5 className="title">Module Settings</h5>
                        </div>

                        <Form action="#" method="post" className="form-horizontal" enctype="multipart/form-data">
                            {/* buy */}
                            {/* <div className="container my-5"> */}
                            <div className="inputmodule">
                                <div className="row align-items-center mb-3">
                                    <div className="col-6">
                                        <label className="labes">Buy</label>
                                    </div>
                                    <div className="col-6 d-flex justify-content-end">
                                        <Form.Check
                                            className="text-black"
                                            type="switch"
                                            id="custom-switch-buy"
                                            checked={audience}
                                            onChange={() => {
                                                const newValue = !audience;
                                                setAudience(newValue);
                                                handleToggle("buy", newValue);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}

                            {/* claim */}
                            {/* <div className="inputmodule">
                                <div className="row align-items-center mb-3">
                                    <div className="col-6">
                                        <label className="labes">Claim</label>
                                    </div>
                                    <div className="col-6 d-flex justify-content-end">
                                        <Form.Check
                                            className="text-white"
                                            type="switch"
                                            id="custom-switch-claim"
                                            checked={port}
                                            onChange={() => {
                                                const newValue = !port;
                                                setPort(newValue);
                                                handleToggle("claim", newValue);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div> */}

                            {/* referral claim */}
                            {/* <div className="inputmodule">
                                <div className="row align-items-center mb-3">
                                    <div className="col-6">
                                        <label className="labes">Referral Claim</label>
                                    </div>
                                    <div className="col-6 d-flex justify-content-end">
                                        <Form.Check
                                            className="text-white"
                                            type="switch"
                                            id="custom-switch-referral"
                                            checked={host}
                                            onChange={() => {
                                                const newValue = !host;
                                                setHost(newValue);
                                                handleToggle("rewardclaim", newValue);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div> */}

                            {/* <button className='btn btns' onClick={(e) => tokenValue(e)}>Submit</button> */}
                        </Form>

                        {/* <form action="#" method="post" className="form-horizontal" enctype="multipart/form-data"> */}
                        {/* <div className="inputItems">
                          <div className="row align-items-center mb-3">
                          <div className="col">
                                                    <label className="labes">Admin2FA</label>
                                                </div>
                                                <div className="col">
                                                    <div className='row'>
                                                        <div className="row">
                                                            <div className="col-3">
                                                                <Form.Check
                                                                    className="mb-4 mb-md-0 text-white"
                                                                    type="radio"
                                                                    label="True"
                                                                    id="Admin2FA-true"
                                                                    name="Admin2FA"
                                                                    value={true}
                                                                    // onChange={() => formik.setFieldValue('Admin2FA', true)}
                                                                    // checked={formik.values.Admin2FA === true ? "true" : null}
                                                                />
                                                            </div>
                                                            <div className="col-3">
                                                                <Form.Check
                                                                    className="mb-4 mb-md-0 text-white"
                                                                    type="radio"
                                                                    label="False"
                                                                    id="Admin2FA-false"
                                                                    name="Admin2FA"
                                                                    value={false}
                                                                    // onChange={() => formik.setFieldValue('Admin2FA', false)}
                                                                    // checked={formik.values.Admin2FA === false ? "false" : null}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    </div>
                                                    </div> */}
                        {/* </div> */}
                        {/* </form> */}

                        {/* <form action="#" method="post" className="form-horizontal" enctype="multipart/form-data">
                          <div className="inputItems">
                              <label>Host</label>
                              <input type="text" className='input' value={host} onChange={(e) => setHost(e.target.value)}  style={{marginLeft: "35px"}}></input>
                          </div>
                          <div className="inputItems">
                              <label>Port</label>
                              <input type="text" className='input' value={port} onChange={(e) => setPort(e.target.value)} style={{marginLeft: "38px"}}></input>
                          </div>
                          <div className="inputItems">
                              <label>User</label>
                              <input type="text" className='input' value={user} onChange={(e) => setUser(e.target.value)} style={{marginLeft: "35px"}}></input>
                          </div>
                          <div className="inputItems">
                              <label>Password</label>
                              <input type="text" className='input' value={password} onChange={(e) => setPassword(e.target.value)}  style={{marginLeft: "-5px"}}></input>
                          </div>
                          <div className="inputItems">
                              <label>Audience</label>
                              <input type="text" className='input' value={audience}  onChange={(e) => setAudience(e.target.value)} ></input>
                          </div>
                       
            </form>
            <button className='btn btns' onClick={(e) => tokenValue(e)}>Submit</button> */}
                    </div>
                </div>

            </div>

        </section>

    )
}

export default ModuleEnableSettings